module.exports = __webpack_public_path__ + "static/media/Trash.7e2a78ec.svg";